import { PermissionOutput, ScopeConfig } from '@app/models/users';

import { IFormValues } from '../interfaces';

import { getRuleValue } from './index';

export const getInitialValues = (config: ScopeConfig[] = [], roles?: PermissionOutput[]): IFormValues =>
  config.reduce(
    (acc, scopeConfig) => ({
      ...acc,
      [scopeConfig.scope]: scopeConfig.actions.reduce(
        (rules, actionConfig) => ({
          ...rules,
          [actionConfig.action]: getRuleValue(scopeConfig.scope, actionConfig.action, roles),
        }),
        {}
      ),
    }),
    {} as IFormValues
  );
